export const toFilenameDateTimeString = (
	date: Date | string | number = Date.now(),
): string =>
	new Date(date)
		.toISOString()
		.slice(0, 16)
		.replace("T", "-T")
		.replace(":", "-")

export const downloadFile = (
	fileName: string,
	fileData: BlobPart[],
	mimeType: string = "text/plain",
) => {
	const blob = new Blob(fileData, { type: mimeType })
	const url = globalThis.URL.createObjectURL(blob)
	const link = document.createElement("a")

	link.href = url
	link.download = fileName
	link.click()
	globalThis.URL.revokeObjectURL(url)
}

export const openFileInNewTab = (
	fileData: BlobPart[],
	mimeType: string = "text/plain",
) => {
	const blob = new Blob(fileData, { type: mimeType })
	const url = globalThis.URL.createObjectURL(blob)
	globalThis.open(url, "_blank", "noopener,noreferrer")
	globalThis.URL.revokeObjectURL(url)
}
